import React, { useState, useEffect } from 'react'
import "./PropertyFilter.scss"
import { Container, Form, Modal, Button } from 'react-bootstrap'
import _ from "lodash"
import { find } from "lodash"
import Select from 'react-select';
import { navigate } from "@reach/router";
import SearchInputBox from '../predictive-search/search-areas';
import { navigate as gatsbyNavigate } from "gatsby";
import { propertyTypes, AvailabilitySales, AvailabilityLettings, priceminRangeResiSale, pricemaxRangeResiSale, priceminRangeResiRent, pricemaxRangeResiRent, bedroomsRange, Sorting } from "../../components/common/propertyUtils";
import $ from 'jquery'
import { isMobile, isMobileOnly } from 'react-device-detect'
const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`

function PropertyFilter(props) {
    // Common Search Navigate
    const pyOptions = propertyTypes
    const onChangeSellRent = (e) => {
        gatsbyNavigate(`/${e.value}`)
    }
    // 
    // Search Filter States
    const [propertyval, setPropertyVal] = useState('');
    const [availability, setAvailability] = useState('');
    const [areaVal, setAreaVal] = useState('');
    const [minpriceVal, setMinPriceVal] = useState('');
    const [maxpriceVal, setMaxPriceVal] = useState('');
    const [sort, setSort] = useState('');
    const [mobilesort, setMobileSort] = useState(false);
    const [bedVal, setBedVal] = useState('');
    const [minPriceList, setMinPriceList] = useState([]);
    const [maxPriceList, setMaxPriceList] = useState([]);
    const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
    const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);
    // 
    // Show Hide More Filter
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // 
    ///// Price Filter Set /////
    // Min price
    const onChangeMinPrice = (e) => {
        setSelectedMinPriceValue(e.value);
    }
    // Min price

    // Max Price
    const onChangeMaxPrice = (e) => {
        setSelectedMaxPriceValue(e.value);
    }
    // Max Price

    // Sales price list
    var minPrice = [];
    var maxPrice = pricemaxRangeResiSale.filter(c => (c.value === "0" || parseInt(c.value) >= parseInt(selectedMinPriceValue)));

    priceminRangeResiSale.map(items => parseInt(items.value) <= parseInt(selectedMaxPriceValue) && minPrice.push(items));

    if (minPrice.length > 0) {
    } else {
        minPrice.push(priceminRangeResiSale[0])
    }

    if (maxPrice.length > 0) {
    } else {
        maxPrice.push(pricemaxRangeResiSale[0])
    }
    // Sales price list

    // Lettings price list
    var minPriceLettings = [];
    var maxPriceLettings = pricemaxRangeResiRent.filter(c => (c.value === "0" || parseInt(c.value) >= parseInt(selectedMinPriceValue)));

    priceminRangeResiRent.map(items => parseInt(items.value) <= parseInt(selectedMaxPriceValue) && minPriceLettings.push(items));

    if (minPriceLettings.length > 0) {
    } else {
        minPriceLettings.push(priceminRangeResiRent[0])
    }

    if (maxPriceLettings.length > 0) {
    } else {
        maxPriceLettings.push(pricemaxRangeResiRent[0])
    }
    // Lettings price list

    // 
    useEffect(() => {
        // 
        if (_.isEmpty(minPriceList)) {
          if (props.type === "lettings") {
            setMinPriceList(priceminRangeResiRent);
            setMaxPriceList(pricemaxRangeResiRent);
          } else {
            setMinPriceList(priceminRangeResiSale)
            setMaxPriceList(pricemaxRangeResiSale)
          }
        }
        //
        
        // Page when load field in text boxes will same
        const url = typeof window !== 'undefined' ? window.location.href : ''
        let pathUri = url.split("/")
        for (let vi = 1; vi <= pathUri.length; vi++) {
          // check for area
          if (typeof pathUri[vi] === "undefined") {
              continue
          }
    
          // Property type
          if (pathUri[vi].indexOf("type-") >= 0) {
            setPropertyVal(pathUri[vi].replace("type-", ""))
          }
          // Property type

          // Availability
          if (pathUri[vi].indexOf("availability-") >= 0) {
            setAvailability(pathUri[vi].replace("availability-", ""))
          }
          // Availability

          // Area
          if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-london") == -1)) {
            setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "")))
          }
          // Area
        
          // Price
            if (
              pathUri[vi].indexOf("between-") >= 0 ||
              pathUri[vi].indexOf("over-") >= 0 ||
              pathUri[vi].indexOf("under-") >= 0
          ) {
              let priceFilt1 = pathUri[vi].split("over-")
              if (priceFilt1[1]) {
                setMinPriceVal(priceFilt1[1])
                setSelectedMinPriceValue(priceFilt1[1]) 
              }
              let priceFilt2 = pathUri[vi].split("under-")
              if (priceFilt2[1]) {
                setMaxPriceVal(priceFilt2[1])
                setSelectedMaxPriceValue(priceFilt2[1])
              }
              let priceFilt3 = pathUri[vi].split("between-")
              if (priceFilt3[1]) {
              let priceFilt4 = priceFilt3[1].split("-and-")
                setMinPriceVal(priceFilt4[0])
                setMaxPriceVal(priceFilt4[1])
                setSelectedMinPriceValue(priceFilt4[0])
                setSelectedMaxPriceValue(priceFilt4[1])
              }
          }
          // Price
    
          // Bedrooms
            if (pathUri[vi].indexOf("-and-more-") >= 0) {
              setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
          }
          // Bedrooms

          // Sort by
          if (pathUri[vi].indexOf("sortby-") >= 0) {
            setSort(pathUri[vi].replace("sortby-", ""))
          }
          // Sort by
      }
        // Page when load field in text boxes will same
      },[props.location]);
    // 
    //  Submit Form on Mobile Sort
    // useEffect(() => {
      
    //     submitSearch();      
      
    // },[mobilesort])
    const HandleSort = (e) => {
      var searchFilterResults = 'sortby-'+e;
      navigate(searchFilterResults);
    }
     // Submit search
  const submitSearch = (e) => {
    
    if(show == true) {
      setShow(false);
    }

    //e.preventDefault();
    var areaValueInput = $(".location-box input.react-autosuggest__input").val().split(', ').join('-').replace("(", "").replace(")", "").replace(/ /g, "-").replace(/---/g, "-").replace(/'/g, "").toLowerCase();
    
    if(isMobileOnly) {
      areaValueInput = !_.isEmpty($(".location-box input.react-autosuggest__input")) && $(".location-box input.react-autosuggest__input")[1] && $(".location-box input.react-autosuggest__input")[1].value.split(', ').join('-').replace("(", "").replace(")", "").replace(/ /g, "-").replace(/---/g, "-").replace(/'/g, "").toLowerCase();
    }
    var areaValue = areaVal
    if(areaValueInput) {
      areaValue = areaValueInput
    } else {
      areaValue = "london"
    }
    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".property input[type='hidden']").val();
    var availabilityValue = availability ? availability : "";
    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-" + minpriceVal + "-and-" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "under-" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "over-" + minpriceVal
        }
    }

    var searchFilterResults = ""

    if(areaValue) {
      searchFilterResults = `${props.locationname}in-${areaValue}/`; 
    } 

    if(availabilityValue){
      searchFilterResults += "availability-" + availability + "/";
    }

    if(buildingValue){
      searchFilterResults += "type-" + buildingValue + "/";
    }

    if(bedroomValue && bedroomValue != "0"){
      searchFilterResults += bedroomValue + "-and-more-bedrooms/";
    }

    if(priceUrl){
      searchFilterResults += priceUrl +"/";
    }
    if(sort){
      searchFilterResults += 'sortby-'+sort+"/";
    }
    navigate(searchFilterResults);
  }
  // Submit search
  
    return (
        <Container>
            <Form action="javascript:;"  method="post" onSubmit={submitSearch}>
                <div className={`filter-wrapper`}>
                    <div className="select-dropdown small-dropdown d-none d-md-block">
                        <Select
                            options={pyOptions}
                            defaultValue={find(pyOptions, ['label', (props.type === "sales" ? 'Buy' : 'Rent')])}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            onChange={(e) => onChangeSellRent(e)}
                        />
                    </div>
                    <div className='input-box location-box d-none d-md-block'>    
                        <SearchInputBox areaVal={areaVal!="london"?areaVal:""}/>                    
                        {/* <input type="text" placeholder='Street, area or postcode'></input> */}
                    </div>
                    <div className="select-dropdown price-dropdown d-none d-xl-block">
                        <Select
                            options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.type === "sales" ? minPrice : minPriceLettings)}
                            value={minPriceList.find(obj => obj.value === minpriceVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            placeholder="Min Price"
                            onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}

                        />
                    </div>
                    <div className="select-dropdown price-dropdown d-none d-xl-block">
                        <Select
                            options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.type === "sales" ? maxPrice : maxPriceLettings)}
                            value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            placeholder="Max Price"
                            onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                        />
                    </div>
                    <div className="select-dropdown bedroom-dropdowm d-none d-xl-block">
                        <Select
                            options={bedroomsRange}
                            placeholderValue={bedVal ? bedVal + " +" : "Bedrooms"}
                            value={bedroomsRange.find(obj => obj.value === bedVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            onChange={e => setBedVal(e.value)}
                        />
                    </div>
                    <div className="select-dropdown d-none d-xl-block">
                        <Select
                            options={props.type === "sales" ? AvailabilitySales : AvailabilityLettings}
                            placeholderValue={availability ? availability : "Availability"}
                            value={props.type === "sales" ? AvailabilitySales.find(obj => obj.value === availability) : AvailabilityLettings.find(obj => obj.value === availability)}
                            onChange={e => setAvailability(e.value)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                        />
                    </div>

                      <div className='more-actions d-lg-block d-xl-none'>
                          <Button  className='btn btn-dark' onClick={handleShow}>
                              Filters<i className='icon-more-filter'></i>
                          </Button>
                      </div>
                      <div className='more-actions mobile-sort d-lg-none d-xl-none d-md-none'>
                        <div className="select-dropdown">
                            <Select
                                options={Sorting}
                                placeholderValue={sort ? sort + " +" : "Sort"}
                                value={Sorting.find(obj => obj.value === sort)}
                                onChange={e => { setSort(e.value); setMobileSort(true); HandleSort(e.value);} }                           
                                isSearchable={false}
                                classNamePrefix={"select-opt"}
                                className="select-control"
                                placeholder="Sort"
                            />
                        </div>
                      </div>
                    
                    <div className='submit-filter d-none d-md-block'>
                        <button className='submit-icon' type="submit"><i className='icon-search'></i></button>
                    </div>
                </div>
                </Form>
                {show &&
                <Modal show={show} onHide={handleClose} className="filter-overlay-modal">
                <Modal.Header closeButton></Modal.Header>
                <div className='more-filters-block d-lg-block d-xl-none'>
                <Form action="javascript:;"  method="post" onSubmit={submitSearch}>
                  <div className="filter-wrapper">
                  <div className="select-dropdown">
                        <Select
                            options={pyOptions}
                            defaultValue={find(pyOptions, ['label', (props.type === "sales" ? 'Buy' : 'Rent')])}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            onChange={(e) => onChangeSellRent(e)}
                        />
                    </div>
                    <div className='input-box location-box'>                        
                        {/* <input type="text" placeholder='Street, area or postcode'></input> */}
                        <SearchInputBox areaVal={areaVal == 'london'?"":areaVal} setAreaVal={setAreaVal}/>                    
                    </div>
                  <div className="select-dropdown price-dropdown">
                        <Select
                            options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.type === "sales" ? minPrice : minPriceLettings)}
                            value={minPriceList.find(obj => obj.value === minpriceVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            placeholder="Min Price"
                            onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}

                        />
                    </div>
                    <div className="select-dropdown price-dropdown">
                        <Select
                            options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.type === "sales" ? maxPrice : maxPriceLettings)}
                            value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            placeholder="Max Price"
                            onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                        />
                    </div>
                    <div className="select-dropdown bedroom-dropdowm">
                        <Select
                            options={bedroomsRange}
                            placeholderValue={bedVal ? bedVal + " +" : "Bedrooms"}
                            value={bedroomsRange.find(obj => obj.value === bedVal)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            onChange={e => setBedVal(e.value)}
                        />
                    </div>
                    <div className="select-dropdown">
                        <Select
                            options={props.type === "sales" ? AvailabilitySales : AvailabilityLettings}
                            placeholderValue={availability ? availability : "Availability"}
                            value={props.type === "sales" ? AvailabilitySales.find(obj => obj.value === availability) : AvailabilityLettings.find(obj => obj.value === availability)}
                            onChange={e => setAvailability(e.value)}
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                        />
                    </div>
                    {/* <div className="select-dropdown">
                        <Select
                            options={Sorting}
                            placeholderValue={sort ? sort + " +" : "Sort"}
                            value={Sorting.find(obj => obj.value === sort)}
                            onChange={e => setSort(e.value)}                            
                            isSearchable={false}
                            classNamePrefix={"select-opt"}
                            className="select-control"
                            placeholder="Sort"
                        />
                    </div> */}

                  </div>
                  <div className='submit-filter'>
                    <button className='btn btn-fill-primary' type="submit">Search</button>
                  </div>
                    </Form>
                </div>
                </Modal>
                }
            
        </Container>
    )
}

export default PropertyFilter